import React, { useEffect, useState } from "react";

const ICONS = {
  success: "✓",
  error:   "✕",
  warning: "⚠",
  info:    "ℹ",
};

const COLORS = {
  success: { bg: "#f0fdf4", border: "#22c55e", icon: "#16a34a", title: "#15803d" },
  error:   { bg: "#fef2f2", border: "#ef4444", icon: "#dc2626", title: "#b91c1c" },
  warning: { bg: "#fffbeb", border: "#f59e0b", icon: "#d97706", title: "#b45309" },
  info:    { bg: "#eff6ff", border: "#3b82f6", icon: "#2563eb", title: "#1d4ed8" },
};

function ToastItem({ id, type = "info", message, onClose }) {
  const [visible, setVisible] = useState(false);
  const c = COLORS[type] || COLORS.info;

  useEffect(() => {
    const show = setTimeout(() => setVisible(true), 10);
    const hide = setTimeout(() => { setVisible(false); setTimeout(() => onClose(id), 300); }, 4500);
    return () => { clearTimeout(show); clearTimeout(hide); };
  }, [id, onClose]);

  return (
    <div onClick={() => { setVisible(false); setTimeout(() => onClose(id), 300); }} style={{
      display: "flex", alignItems: "flex-start", gap: 10,
      background: c.bg, border: `1px solid ${c.border}`, borderLeft: `4px solid ${c.border}`,
      borderRadius: 8, padding: "12px 14px", marginBottom: 8,
      boxShadow: "0 4px 12px rgba(0,0,0,0.12)", cursor: "pointer", minWidth: 280, maxWidth: 380,
      transition: "all 0.3s ease",
      opacity: visible ? 1 : 0,
      transform: visible ? "translateX(0)" : "translateX(40px)",
    }}>
      <div style={{
        width: 22, height: 22, borderRadius: "50%", background: c.border,
        color: "#fff", display: "flex", alignItems: "center", justifyContent: "center",
        fontSize: 12, fontWeight: 700, flexShrink: 0, marginTop: 1,
      }}>
        {ICONS[type]}
      </div>
      <div style={{ flex: 1, fontSize: 13, color: "#374151", lineHeight: 1.5 }}>
        {message}
      </div>
    </div>
  );
}

export default function Toast({ toasts, onClose }) {
  if (!toasts.length) return null;
  return (
    <div style={{
      position: "fixed", top: 20, right: 20, zIndex: 9999,
      display: "flex", flexDirection: "column", alignItems: "flex-end",
    }}>
      {toasts.map(t => (
        <ToastItem key={t.id} {...t} onClose={onClose} />
      ))}
    </div>
  );
}

let _nextId = 1;
export function useToast() {
  const [toasts, setToasts] = useState([]);

  const show = (message, type = "info") => {
    const id = _nextId++;
    setToasts(prev => [...prev, { id, message, type }]);
  };

  const close = (id) => setToasts(prev => prev.filter(t => t.id !== id));

  return {
    toasts,
    closeToast: close,
    success: (msg) => show(msg, "success"),
    error:   (msg) => show(msg, "error"),
    warning: (msg) => show(msg, "warning"),
    info:    (msg) => show(msg, "info"),
  };
}
